export class Abstract {

	_form;
	_node;

	static init(form, nodeSelector) {
		form.getNode()
			.querySelectorAll(nodeSelector)
			.forEach((node) => {
				form.addElement(new this(form, node));
			});
	}

	constructor(form, node) {
		this._form = form;
		this._node = node;
		console.log('Abstract.constructor', node);
	}

	getNodeName() {
		return this._node.name;
	}

	getData() {
		return this._node.value;
	}

	setHtmlContent(content) {
		this._node.html(content);
	}

	enable() {}

	disable() {}

	error(error = null) {}

	notice(notice = null) {}

	message(message = null) {}

	value(value) {}

	show() {}

	hide() {}
}
